import ModelBaseClass from "@quasidea/oas-client-react/lib/ModelBaseClass";
import CashCollectionDepositRequest from "../CashCollectionDepositRequest";
import ModelProxyClass from "./ModelProxyClass";


/**
 * @class CashCollectionDepositRequestBase
 * @extends ModelBaseClass
 * @property {[number]} cashCollectionIds
 * @property {number} cashAccountId (int64) the vault or bank cashAccount that this is being deposited to
 */
class CashCollectionDepositRequestBase extends ModelBaseClass {
	/**
	 * @type {[number]} cashCollectionIds
	 */
	cashCollectionIds;
	/**
	 * the vault or bank cashAccount that this is being deposited to
	 * @type {number} cashAccountId (int64)
	 */
	cashAccountId;

	/**
	 * Instantiates a new instance of CashCollectionDepositRequest based on the generic object being passed in (typically from a JSON object)
	 * @param {object} genericObject
	 * @return {CashCollectionDepositRequest}
	 */
	static create(genericObject) {
		const newCashCollectionDepositRequest = new CashCollectionDepositRequest();
		newCashCollectionDepositRequest.instantiate(_modelDefinition, genericObject, ModelProxyClass.createByClassName);
		return newCashCollectionDepositRequest;
	}

	/**
	 * Instantiates a new array of CashCollectionDepositRequest based on the generic array being passed in (typically from a JSON array)
	 * @param {[object]} genericArray
	 * @return {[CashCollectionDepositRequest]}
	 */
	static createArray(genericArray) {
		if (genericArray === null) {
			return null;
		}

		const newCashCollectionDepositRequestArray = [];
		genericArray.forEach(genericObject => {
			newCashCollectionDepositRequestArray.push(CashCollectionDepositRequest.create(genericObject));
		});
		return newCashCollectionDepositRequestArray;
	}
}

const _modelDefinition = [
	ModelBaseClass.createModelProperty('cashCollectionIds', '[integer]'),
	ModelBaseClass.createModelProperty('cashAccountId', 'integer'),
];

export default CashCollectionDepositRequestBase;
